/**
 * Scarcity counter.
 *
 * A deliberately fixed starting number, not live inventory. It steps down by
 * one per page view inside a browser session, is floored by the schema
 * minimum, and resets to the starting number on a fresh session.
 *
 * Defined once here rather than from an inline script per block, so that any
 * instance added later — by the Section Rendering API, a morph, or the theme
 * editor — upgrades straight from the registry without a script re-running.
 */

const TAG = 'scarcity-counter';

class ScarcityCounter extends HTMLElement {
  connectedCallback() {
    if (!this.render()) requestAnimationFrame(() => this.render());
  }

  render() {
    if (this.rendered) return true;

    const output = this.querySelector('.scarcity-counter__number');
    if (!output) return false;

    output.textContent = String(this.resolveCount());
    this.rendered = true;
    return true;
  }

  resolveCount() {
    const start = Number(this.dataset.startingCount) || 14;
    const min = Number(this.dataset.minimumCount) || 0;
    const key = this.dataset.storageKey;

    let count = start;
    try {
      const stored = sessionStorage.getItem(key);
      if (stored !== null) count = Number.parseInt(stored, 10) - 1;
      if (!Number.isFinite(count)) count = start;
      count = Math.min(start, Math.max(min, count));
      sessionStorage.setItem(key, String(count));
    } catch {
      // Storage blocked (private mode, sandboxed frame) — show the start value.
      count = start;
    }
    return count;
  }
}

if (!customElements.get(TAG)) customElements.define(TAG, ScarcityCounter);
